/**
 * Contactos de un prospecto del CRM comercial. Antes había UN solo contacto
 * (campos planos contactoNombre/Tel/Email); ahora es un arreglo `contactos`
 * con nombre + rol + tel + email (varios por edificio). `contactosDeCrm` lee el
 * arreglo nuevo y, si no existe, sintetiza el contacto legacy — así las fichas
 * viejas siguen funcionando sin migración.
 */

export const ROLES_CONTACTO = [
  { value: "", label: "Rol (opcional)" },
  { value: "presidente", label: "Presidente/a" },
  { value: "comision", label: "Integrante de comisión" },
  { value: "propietario", label: "Propietario/a" },
  { value: "portero", label: "Portero / encargado" },
  { value: "administrador", label: "Administrador/a saliente" },
  { value: "inmobiliaria", label: "Inmobiliaria" },
  { value: "otro", label: "Otro" },
];

export const ROL_LABELS = Object.fromEntries(
  ROLES_CONTACTO.filter((r) => r.value).map((r) => [r.value, r.label])
);

const c = (x) => ({ nombre: x?.nombre || "", rol: x?.rol || "", tel: x?.tel || "", email: x?.email || "" });

/** Lista de contactos de un doc CRM (arreglo nuevo, o el contacto legacy, o []). */
export function contactosDeCrm(crm) {
  if (Array.isArray(crm?.contactos) && crm.contactos.length) return crm.contactos.map(c);
  if (crm?.contactoNombre || crm?.contactoTel || crm?.contactoEmail) {
    return [{ nombre: crm.contactoNombre || "", rol: "", tel: crm.contactoTel || "", email: crm.contactoEmail || "" }];
  }
  return [];
}

/** Normaliza y descarta contactos totalmente vacíos (para guardar). */
export function contactosLimpios(list) {
  return (list || [])
    .map(c)
    .map((x) => ({ nombre: x.nombre.trim(), rol: x.rol, tel: x.tel.trim(), email: x.email.trim() }))
    .filter((x) => x.nombre || x.tel || x.email);
}

/** Resumen corto de un contacto para listados ("Ana · Presidenta"). */
export function contactoResumen(ct) {
  const rol = ct.rol ? ROL_LABELS[ct.rol] || ct.rol : "";
  return [ct.nombre, rol].filter(Boolean).join(" · ");
}
